<template>
  <div>
    <div v-if="formData.infoDesc">
      <div class="title-div">
        <img
          class="title-bg"
          src="@/assets/images/contact-address-title-bg.png"
        />
        <img
          class="title-ico"
          src="@/assets/images/contact-address-title-ico.png"
        />
        <label class="title-label">方案简介</label>
      </div>
      <p>{{ $tc("message.caseInfoList[" + formData.index + "].infoDesc") }}</p>

      <div class="mid">
        <img
          :src="require('../../../assets/images/' + formData.infoSrc + '')"
        />
      </div>
    </div>

    <div v-if="formData.solutionDesc">
      <div class="title-div">
        <img
          class="title-bg"
          src="@/assets/images/contact-address-title-bg.png"
        />
        <img
          class="title-ico"
          src="@/assets/images/contact-address-title-ico.png"
        />
        <label class="title-label">解决方案</label>
      </div>
      <p>
        {{ $tc("message.caseInfoList[" + formData.index + "].solutionDesc") }}
      </p>
      <div class="mid">
        <img
          :src="require('../../../assets/images/' + formData.solutionSrc + '')"
        />
      </div>
    </div>
    <div v-if="formData.advantageDesc">
      <div class="title-div">
        <img
          class="title-bg"
          src="@/assets/images/contact-address-title-bg.png"
        />
        <img
          class="title-ico"
          src="@/assets/images/contact-address-title-ico.png"
        />
        <label class="title-label">产品优势</label>
      </div>
      <p>
        {{ $tc("message.caseInfoList[" + formData.index + "].advantageDesc") }}
      </p>
      <div class="mid">
        <img
          :src="require('../../../assets/images/' + formData.advantageSrc + '')"
        />
      </div>
    </div>
    <div v-if="formData.valueDesc">
      <div class="title-div">
        <img
          class="title-bg"
          src="@/assets/images/contact-address-title-bg.png"
        />
        <img
          class="title-ico"
          src="@/assets/images/contact-address-title-ico.png"
        />
        <label class="title-label">应用价值</label>
      </div>
      <p>{{ $tc("message.caseInfoList[" + formData.index + "].valueDesc") }}</p>
      <div class="mid">
        <img
          :src="require('../../../assets/images/' + formData.valueSrc + '')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CompanySpecialty from "@/pages/company/components/ContentSpecialty";
export default {
  name: "SolutionContent",
  components: {
    CompanySpecialty
  },
  props: {
    formData: {
      infoSrc: "",
      infoDesc: "",
      solutionSrc: "",
      solutionDesc: ""
    }
  },
  data() {
    return {
      title: "物联网快速响应",
      des: "",
      content:
        "实时推送故障报警、质量缺陷、风险问题等信息，到智能设备、广播系统，准确定位，极大缩短响应时间，提高生产效率。"
    };
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.mid {
  text-align: center;

  img {
    width: 100%;
  }
}

p {
  line-height: 2em;
}

.el-tabs {
  box-shadow: 0rem 0.3rem 0.8rem 0rem rgba(2, 0, 0, 0.11);
  padding-top: 2rem;
  padding-bottom: 2rem;

  .label-did {
    color: #12b7f6;
    font-size: 1.3rem;
  }

  .label {
    color: #333333;
    font-size: 1.3rem;
  }
}

.content-ico {
  height: 5.6rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  margin-left: 50%;
  transform: translateX(-50%);
}

.content-solution {
  width: 70%;
}

.content-title {
  margin-top: 0.5em;
  font-size: 1.9rem;
  color: #666666;
}

.content-img {
  width: 100%;
  margin-top: 1rem;
}

.content-desc {
  font-size: 17px;
  margin-top: 1rem;
  color: #666666;
  letter-spacing: 0.1rem;
}

.title-div {
  position: relative;
  margin-top: 3rem;
  // width: 100%;
  height: 2.8rem;

  .title-bg {
    height: 2.8rem;
  }

  .title-ico {
    position: absolute;
    height: 1.2rem;
    left: 0.7rem;
    top: 50%;
    transform: translateY(-50%);
  }

  .title-label {
    position: absolute;
    color: #ffffff;
    left: 3.3rem;
    font-size: 1.3rem;
    line-height: 2.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/case/components/CaseContent.vue